import api from 'api'
import { CACHE_TAG_ACCOUNT_CONTAINER_LIST } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getAccountContainers: builder.query({
      query: ({ accountId, locationId }) => ({
        url: `/api/v1/core/accounts/${accountId}/container`,
        method: 'GET',
        ...(locationId && { params: { locationId } }),
      }),
      providesTags: [CACHE_TAG_ACCOUNT_CONTAINER_LIST],
    }),
  }),
})

export const { useLazyGetAccountContainersQuery } = extendedApi
